import { MutualFundFamily } from 'api/models/MutualFundFamily';
import { CompaniesService } from 'api/services/CompaniesService';
import { FundFamilySuggestion } from './FundFamiliesSection.types';

export const fetchFamilies = (): Promise<MutualFundFamily[]> =>
  CompaniesService.apiCompaniesMutualFundFamiliesList().then(r => r.results);

export const fetchSuggestions = (): Promise<FundFamilySuggestion[]> =>
  CompaniesService.apiCompaniesMutualFundFamiliesSuggestionsList() as Promise<FundFamilySuggestion[]>;

export const acceptSuggestion = (payload: { name: string; members: string[] }): Promise<MutualFundFamily> =>
  CompaniesService.apiCompaniesMutualFundFamiliesSuggestionsAcceptCreate(payload) as Promise<MutualFundFamily>;
